<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <ImpInspLotForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ImpInspLotForm from '@/components/organisms/terminal/form/ImpInspLotForm'

export default {
  name: 'ImpInspLotPage',

  components: {
    ImpInspLotForm,
  },
}
</script>
